import * as S from './index.style'

export type FlagProps = {
  /** Texto exibido no componente */
  text?: string

  /** Propriedade que pode ser usada para customizar a cor de fundo do botão */
  backgroundColor?: string
}

/** Componente para exibição de texto com background personalizado */
export const Flag: React.FC<FlagProps> = ({ text = '', backgroundColor = 'white' }) => {
  return (
    <S.Wrapper backgroundColor={backgroundColor}>
      <S.Label data-cy="labelSituacaoTerreno">
        Status: <b>{text}</b>
      </S.Label>
    </S.Wrapper>
  )
}
export default Flag
